/**
 * Animations Module - Handles scroll-triggered animations and tracking
 */

/**
 * Setup IntersectionObserver for fade-in animations on elements with the '.fade-in' class.
 * @returns {void}
 */
export function setupScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
}

/**
 * Setup Analytics Visibility Tracking to log an impression when an article is scrolled into view.
 * @param {Function} trackCallback - The callback function to send the event to analytics (e.g., gtag wrapper).
 * @returns {void}
 */
export function setupVisibilityTracking(trackCallback) {
  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const article = entry.target;
        const category = article.getAttribute('data-news-category');
        const title = article.getAttribute('data-news-title');

        if (!title) return;

        // Option B: Limit to once per session using sessionStorage
        const sessionKey = `tracked_impression_${btoa(title).substring(0, 32)}`;
        if (sessionStorage.getItem(sessionKey)) {
          visibilityObserver.unobserve(article);
          return;
        }

        if (trackCallback) {
          trackCallback('news_impression', {
            'news_category': category,
            'news_title': title
          });
          sessionStorage.setItem(sessionKey, 'true');
        }

        visibilityObserver.unobserve(article);
      }
    });
  }, { threshold: 0.5 });

  const attachTracking = () => {
    document.querySelectorAll('article[data-news-category]').forEach(el => {
      visibilityObserver.observe(el);
    });
  };

  attachTracking();

  // Watch for dynamic content changes
  const mainContent = document.getElementById('main-content');
  if (mainContent) {
    const domObserver = new MutationObserver(() => attachTracking());
    domObserver.observe(mainContent, { childList: true, subtree: true });
  }
}
